import { Vector2Tuple } from 'three';

import { FNode } from '../types/index.js';

export const getWorldPosition = (node: FNode): Vector2Tuple => {
  const worldPosition = [...node.position] as Vector2Tuple;
  let currentNode = node;
  while (currentNode.parent && (currentNode.parent as FNode).position) {
    currentNode = currentNode.parent as FNode;
    worldPosition[0] += currentNode.position[0];
    worldPosition[1] += currentNode.position[1];
  }
  return worldPosition;
};
